import React, { useState } from 'react';
import { Button, Container, Grid, Paper, TextField, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import securedInstance from '../../../../api/securedInstance';
import { toast } from 'react-toastify';

const UploadHiringPartnerForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', logo_url: '', is_active: 1 });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) { toast.error('Company name is required'); return; }
    try {
      await securedInstance.post('/api/hiring-partners', formData);
      toast.success('Hiring partner added');
      navigate('/auth/allHiringPartners');
    } catch {
      toast.error('Failed to add');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', mt: 4 }}>
      <Paper elevation={2} sx={{ padding: '28px', width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>Add Hiring Partner</Typography>
          <Button onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

          <Grid container spacing={2} sx={{ border: '1px solid rgba(0,0,0,0.125)', padding: '20px' }}>
            <Grid item xs={12}>
              <TextField label="Company Name" name="name" fullWidth required
                value={formData.name} onChange={handleChange} placeholder="e.g. Infosys" />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Logo URL" name="logo_url" fullWidth
                value={formData.logo_url} onChange={handleChange}
                placeholder="https://logo.clearbit.com/infosys.com" />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox checked={Boolean(formData.is_active)}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked ? 1 : 0 })} />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth style={{ backgroundColor: '#3251A3' }}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UploadHiringPartnerForm;
